<template>
  <div>
    <ul>
      <p class="menu-label removeName">
        Remove a {{ this.type }} from your university list
      </p>
      <li v-for="group in groups" :key="group.id">
        <button
          style="margin-top: 0.5em"
          class="delButton"
          @click="removeGroup(group)"
        >
          {{ getGroupName(group) }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import db from "@/db";
import firebase from "@/firebase";

export default {
  data: () => ({
    groups: [],
    groupIds: [],
    type: "",
    groupCollection: "",
  }),

  computed: {
    ...mapState("groups", [
      "isEditing",
      "isAdding",
      "isCreating",
      "isCourse",
      "isFaculty",
      "isGroup",
      "isShowingSubjects",
      "isShowingGroupTypes",
    ]),
    ...mapState("user", ["user"]),
  },

  mounted() {
    this.init();
  },

  methods: {
    ...mapActions("groupInfo", ["getGroupIdType", "getGroupsFromType"]),
    ...mapActions("groups", ["getGroupName"]),
    ...mapActions("user", ["updateUserGroups"]),
    ...mapActions("messageBoard", ["unsubscribeFromTopic"]),

    init() {
      if (this.isCourse) {
        this.type = "Course";
        this.groupCollection = "courses";
        this.groups = this.user.courses;
        this.groupIds = this.user.course_ids;
      } else if (this.isFaculty) {
        this.type = "Faculty";
        this.groupCollection = "faculties";
        this.groups = this.user.faculties;
        this.groupIds = this.user.faculty_ids;
      } else {
        this.type = "Group";
        this.groupCollection = "groups";
        this.groups = this.user.groups;
        this.groupIds = this.user.group_ids;
      }
    },

    getGroupName(group) {
      return group.name;
    },

    async removeGroup(group) {
      const groupId = await this.getGroupIdType(group);
      for (const index in this.groups) {
        if ((await this.getGroupIdType(this.groups[index])) == groupId) {
          this.groups.splice(index, 1);
        }
      }
      this.groupIds.splice(this.groupIds.indexOf(groupId), 1);

      this.updateUserGroups();
      this.decrementGroupCount(groupId);
      this.addUserLeftGroupPost(groupId, this.getGroupName(group));
      this.displayDifferentGroup();

      this.$store.commit("groups/setIsEditing", false);
    },

    decrementGroupCount(id) {
      db.collection(this.groupCollection)
        .doc(id)
        .update({
          userCount: firebase.firestore.FieldValue.increment(-1),
        });
    },

    addUserLeftGroupPost(id) {
      db.collection("posts").add({
        content:
          this.user.firstName + " " + this.user.lastName + " left the group",
        files: [],
        course_id: id,
        created_at: Date.now(),
        profileImage: this.user.profileImage,
      });
    },

    async displayDifferentGroup() {
      if (this.groups.length > 0) {
        const id = await this.getGroupIdType(this.groups[0]);

        this.$store.commit("messageBoard/setGroupId", id);
        this.$router.replace({
          name: "MessageBoard",
          params: {
            name: this.getGroupName(this.groups[0]).replace(/\s/g, ""),
          },
        });
      } else {
        this.$router.replace({
          name: "Profile",
        });
      }
    },
  },
};
</script>
